export const cardTitleProps = {
  class: 'font-weight-bold justify-center',
}
